import React from 'react'
import {
  MiniUpsales,
  UpsaleSizeType,
  UpsaleType,
} from '../MiniUpsales.tsx/MiniUpsales'
import { useCurrentUpsale } from 'src/hooks/useCurrentUpsale'
import { useActions } from 'src/hooks'
import { useFormatSOCMediaUrl } from 'src/hooks/useFormatSOCMediaUrl'
import usePlanInfo from 'src/hooks/usePlanInfo'

type CurrentMiniUpsaleProps = {
  size?: UpsaleSizeType
  type?: UpsaleType
  shouldReverseOrder?: boolean
  shouldReverseAction?: boolean
  shouldStackAction?: boolean
  imageWidth?: string
  imageHeight?: string
}

export const CurrentMiniUpsale = (props: CurrentMiniUpsaleProps) => {
  const {
    size = 'Large',
    type = 'Ocean',
    shouldReverseOrder,
    shouldReverseAction,
    shouldStackAction,
    imageWidth,
    imageHeight,
  } = props
  const { plan } = useCurrentUpsale()
  const { upsaleInfo } = usePlanInfo(plan)

  const actions = useActions()

  const image = useFormatSOCMediaUrl(upsaleInfo.miniUpsale.image)

  if (!plan) return <></>

  return (
    <MiniUpsales
      size={size}
      type={type}
      shouldReverseAction={shouldReverseAction}
      shouldReverseOrder={shouldReverseOrder}
      shouldStackAction={shouldStackAction}
      image={{ imgUrl: image, width: imageWidth, height: imageHeight }}
      title={upsaleInfo.miniUpsale.description ?? ''}
      primaryAction={{
        title: upsaleInfo.miniUpsale.btnTitle ?? '',
        onClick: () => {
          actions.setUpsellSlug('WILDCARD')
          actions.setPlanToDisplay(plan)
          actions.setShouldShowUpsell(true)
        },
      }}
    />
  )
}
